import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MARK_MESSAGE_AS_READ } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

export const useMarkMessageAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ messageID, userID, path, timestamp }) => {
      // Keep the same expiry the create resolver set (creation + 30 days) --
      // this mutation overwrites the item's DynamoDB TTL, so passing "now"
      // would delete the message as soon as it was read.
      const THIRTY_DAYS = 30 * 24 * 60 * 60;
      const createdAt = Date.parse(timestamp);
      const contractTTL = Number.isFinite(createdAt)
        ? Math.floor(createdAt / 1000) + THIRTY_DAYS
        : Math.floor(Date.now() / 1000) + THIRTY_DAYS;
      return graphQLClient.request(MARK_MESSAGE_AS_READ, {
        messageID,
        userID,
        path,
        contractTTL,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },
    onError: (error) => {
      console.error("Error marking message as read:", error);
    },
  });
};
